
export const BASE_URL = process.env.REACT_APP_API_URL;
export const BASE_IMAGE_URL =process.env.REACT_APP_CDN_URL;
export const GraphQL = "graphql";